export default "__VITE_ASSET__IwHi1REv__"